module.exports = __webpack_public_path__ + "static/img/new_bg.84a29da3.jpg";